
import { genericGet } from './apiService';
import { API_URL } from '../config/env';

/**
 * Ülkeleri getir
 * @returns {Promise<Object>} - Sunucudan dönen yanıt
 */
export const Notification = async () => {
  try {
    const response = await genericGet(`${API_URL}Notification/GetAllList`);
    return response;
  } catch (error) {
    throw error;
  }
};